export default {
  'walletaddress.form.title': '绑定钱包地址',
  'walletaddress.remove.title': '是否删除以绑定钱包地址？',
  'walletaddress.status.pending': '申请中',
  'walletaddress.status.success': '正常',
};